import { css } from '@emotion/react';

import Mixin from '../../../util/mixin';


export class ResetText extends Mixin {
  style({$}){
    return css`
      font-family: ${$.fontFamilyBase};
      font-style: normal;
      font-weight: ${$.fontWeightNormal};
      line-height: ${$.lineHeightBase};
      text-align: left; /* Fallback for where \`start\` is not supported */
      text-align: start;
      text-decoration: none;
      text-shadow: none;
      text-transform: none;
      letter-spacing: normal;
      word-break: normal;
      word-spacing: normal;
      white-space: normal;
      line-break: auto;
    `;
  }
}
